var render = function () {
  var _vm$fetchedUsers, _vm$fetchedUsers2, _vm$fetchedUsers3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "UserIcon",
      "size": "30"
    }
  }), _vm._v(" Professores ")], 1)]), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSubmitSearch.apply(null, arguments);
      }
    }
  }, [_c('b-input-group', {
    staticClass: "input-group-merge"
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Buscar Professor"
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.filtro.name,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "name", $$v);
      },
      expression: "filtro.name"
    }
  })], 1)], 1)], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "lg": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary button-right",
      "to": '/ProfessorLista/cadastrar'
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Adicionar Professor ")], 1)], 1)], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "mb-1 mb-md-0",
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "font-small-3 font-weight-bold"
  }, [_vm._v("Escola")]), _c('v-select', {
    attrs: {
      "options": _vm.escolaOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Todas as escolas"
    },
    on: {
      "input": _vm.onEscolaChange
    },
    model: {
      value: _vm.filtro.schoolId,
      callback: function callback($$v) {
        _vm.$set(_vm.filtro, "schoolId", $$v);
      },
      expression: "filtro.schoolId"
    }
  })], 1)], 1)], 1), (_vm$fetchedUsers = _vm.fetchedUsers) !== null && _vm$fetchedUsers !== void 0 && _vm$fetchedUsers.totalItems ? _c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('div', {
    staticClass: "align-self-center text-muted"
  }, [_vm._v(" Total: "), _c('strong', [_vm._v(_vm._s(_vm.fetchedUsers.totalItems))]), _vm._v(" professor(es) ")]), _c('b-pagination', {
    staticClass: "ml-auto mb-0",
    attrs: {
      "total-rows": _vm.fetchedUsers.totalItems,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e(), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-table', {
    ref: "refUserListTable",
    staticClass: "position-relative",
    attrs: {
      "items": (_vm$fetchedUsers2 = _vm.fetchedUsers) === null || _vm$fetchedUsers2 === void 0 ? void 0 : _vm$fetchedUsers2.content,
      "responsive": "",
      "fields": _vm.tableColumns,
      "primary-key": "id",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.isSortDirDesc,
      "no-local-sorting": "",
      "show-empty": "",
      "empty-text": "Não há professores cadastrados"
    },
    on: {
      "update:sortBy": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sort-by": function updateSortBy($event) {
        _vm.sortBy = $event;
      },
      "update:sortDesc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      },
      "update:sort-desc": function updateSortDesc($event) {
        _vm.isSortDirDesc = $event;
      },
      "sort-changed": _vm.onSortChanged
    },
    scopedSlots: _vm._u([{
      key: "cell(school)",
      fn: function fn(data) {
        var _data$item$school;

        return [_c('span', [_vm._v(_vm._s(((_data$item$school = data.item.school) === null || _data$item$school === void 0 ? void 0 : _data$item$school.name) || '-'))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "no-caret": "",
            "right": _vm.$store.state.appConfig.isRTL
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "align-middle text-body",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'ProfessorEditar',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Editar Professor")])], 1), _c('b-dropdown-item', {
          attrs: {
            "to": {
              name: 'ProfessorTurmas',
              params: {
                id: data.item.id
              }
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "UsersIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Ver Turmas")])], 1), _c('b-dropdown-divider'), _c('b-dropdown-item', {
          staticClass: "text-danger",
          on: {
            "click": function click($event) {
              return _vm.confirmarExclusao(data.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', {
          staticClass: "align-middle ml-50"
        }, [_vm._v("Excluir Professor")])], 1)], 1)];
      }
    }])
  })], 1), (_vm$fetchedUsers3 = _vm.fetchedUsers) !== null && _vm$fetchedUsers3 !== void 0 && _vm$fetchedUsers3.totalItems ? _c('div', {
    staticClass: "d-flex mt-1"
  }, [_c('b-pagination', {
    staticClass: "ml-auto",
    attrs: {
      "total-rows": _vm.fetchedUsers.totalItems,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }